<template>
  <div class="">
    <span class="flex justify-center text-gray-600">現在工事中</span>
  </div>
</template>